// extracted by mini-css-extract-plugin
module.exports = {"badge":"UserTypeCell-badge-1qBBS6"};